import {Component, Input} from '@angular/core'

@Component({
  selector: 'bgo-language-flag',
  templateUrl: './language-flag.component.html',
  styles: [':host {display: block;}'],
})
export class LanguageFlagComponent {
  @Input()
  set language(value: ProSpokenLanguage) {
    this._language = value
    this.flagPath = `assets/images/profile/languages/${value}.png`
  }
  get language(): ProSpokenLanguage {
    return this._language
  }

  private _language!: ProSpokenLanguage
  flagPath!: string
}

export enum ProSpokenLanguage {
  GERMAN = 'de',
  FRENCH = 'fr',
  ENGLISH = 'en',
  ITALIAN = 'it',
}
